<template>
  <div>
    <el-upload
                style="float:right "
      :action="postUrl"
      multiple
      :limit="1"
      name="docFile0"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
    >
      <el-button size="small"class="file">上传 </el-button>
    </el-upload>
  </div>
</template>
<script>
import axios from 'axios'
// import { upload } from '../api/LoginApi.js'
export default {
  data () {
    return {
      // 拼接文件上传地址，loginguid从登陆成功的参数里获取
      postUrl:
        'http://112.74.51.55:666/web/cpc/filesuploadsave2.do?loginguid=' +
        localStorage.getItem('loginguid'),
      fileList: []
    }
  },
  methods: {
    UploadSubmit (param) {
      // 自定义上传（手动上传）
      let file = param.file
      // console.log(param.file);
      let fileForm = new FormData() // 获取上传表单（文件）
      fileForm.append('file', file)
      axios({
        url: 'http://127.0.0.1:8081/upload',
        method: 'POST',
        headers: {
          token: localStorage.getItem('token')
        },
        data: fileForm
      })
        .then(res => {
          console.log(res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    submitUpload () {
      this.$refs.upload.submit()
    },
    fileRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },

    async handleAvatarSuccess (res, file) {
      console.log('res', res)
      if (res.data) {
        alert('文件上传成功，文件ID是：' + res.data[0].docid)
      }
    },
    beforeAvatarUpload (file) {
      console.log('file2', file)
    },
    doupload () {
      return null // 一次接口
    },
    uploadActionUrl (file) {
      //  表单提交方式
      let FormDatas = new FormData()
      FormDatas.append('file', file)
      FormDatas.append('bizTable', 'candidate') // 其他参数
      FormDatas.append('bizId', '6') // 候选人id<===========!
      console.log(FormDatas)
      let that = this
      that
        .$http({
          method: 'post',
          url:
            'http://112.74.51.55:666/web/cpc/filesuploadsave2.do?loginguid=SEAGULL.a.{Web_16247026810180.367845529094449}',
          headers: 'multipart/form-data',
          data: FormDatas
        })
        .then(function (res) {
          console.log('response', res)
        })
    }
  },
  created () {}
}
</script>



// WEBPACK FOOTER //
// src/components/test1.vue